import { useMutation, useQuery } from '@tanstack/react-query';

import { getStatisticProblemsDictionary, getProblemClientsStatistic } from '../../../../api';
import { PageParams } from '../../../../types/pagination';

export const useProblemClientsStatistic = () =>
  useMutation({
    mutationKey: ['getProblemClientsStatistic'],
    mutationFn: (params: PageParams) => getProblemClientsStatistic(params),
  });

export const useProblemsDictionary = () =>
  useQuery({ queryKey: ['getStatisticProblemsDictionary'], queryFn: () => getStatisticProblemsDictionary() });
